import { render } from "./HistoryPopup.vue?vue&type=template&id=f83608a6&scoped=true"
import script from "./HistoryPopup.vue?vue&type=script&lang=js"
export * from "./HistoryPopup.vue?vue&type=script&lang=js"

import "./HistoryPopup.vue?vue&type=style&index=0&id=f83608a6&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f83608a6"]])

export default __exports__